import { JsonLdSchema } from 'types/metadata'

/**
 * Escape characters that are unsafe inside an inline <script> element so the
 * serialized JSON-LD cannot break out of the script context (stored/DOM XSS).
 * Escaping `<`/`>`/`&` makes a literal `</script>` (or `<!--`) sequence
 * impossible, and U+2028/U+2029 are invalid raw in JS string literals.
 * The escapes are valid JSON, so consumers (e.g. Google) parse them back.
 */
const UNSAFE_SCRIPT_CHARS = new RegExp('[<>&\\u2028\\u2029]', 'g')

const escapeForScript = (json: string): string =>
  json.replace(
    UNSAFE_SCRIPT_CHARS,
    (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, '0')}`
  )

export const PrepareSchema = (schema: JsonLdSchema): string | null => {
  if (typeof schema.url === 'string') {
    schema.url = encodeURI(schema.url)
  }

  const serialized = JSON.stringify(schema)
  if (!serialized) {
    return null
  }

  return escapeForScript(serialized)
}
